import { API_URL as baseApiUrl } from "@/config/env";

export const dashBoardUrls = {
  quotaSubmittionStatusData: baseApiUrl + "Quota/GetQuotaStatusGrpahData?",
  consumptionByCountry: baseApiUrl + "Home/GetScenarioConsumptionByCountry?",
  geoData: baseApiUrl + "Home/GetGeoChart",
  synchronizationStatus: baseApiUrl + "Home/GetSynchronizationStatus?",
  orderStatus: baseApiUrl + "Home/GetOrderStatus?",
  userCountries: baseApiUrl + "GetUserCountries?",
  scenarios: baseApiUrl + "GetScenarios?",
  approvalStats: baseApiUrl + "Home/GetApprovalStatistics?",
  scenarioCriticalityList: baseApiUrl + "Scenario/GetScenarioCriticalityList",
};

export const sizes = {
  w650: 650,
  w450: 450,
  w300: 300,
  w270: 270,
  w250: 250,
  w200: 200,
  w150: 150,
  h35: 35,
};

export function prepareQuotaSubmissoinStatusData(data) {
  let entities = [...new Set(data.map((obj) => obj.entity))];
  let countries = [...new Set(data.map((obj) => obj.geoName))];

  let statuses = {};
  for (let i = 0; i < entities.length; ++i) {
    statuses[entities[i]] = new Array(countries.length).fill(0);
  }

  for (let i = 0; i < data.length; ++i) {
    const obj = data[i];
    const { geoName, entity, cnt } = obj;
    const index = countries.indexOf(geoName);

    statuses[entity][index] = cnt;
  }

  // if (entities[0] == "Active Scenarios") {
  //   for (let i = 0; i < countries.length; i++) {
  //     statuses["Active Scenarios"][i] =
  //       parseInt(statuses["Quota Approved"][i]) +
  //       parseInt(statuses["Quota Pending for Submission"][i]) +
  //       parseInt(statuses["Quotas Pending for Approval"][i]);
  //   }
  // }

  const preparedData = {
    countries,
    statuses,
  };

  return preparedData;
}

export function prepareConsumptionData(data) {
  let categories = [];
  let values = [];
  for (let i = 0; i < data.length; ++i) {
    const obj = data[i];
    categories.push(obj.countryName);
    values.push(obj.consumptionRatio.toFixed(1));
  }

  const preparedData = {
    categories,
    values,
  };

  return preparedData;
}

export function prepareScenarioConsumptionData(data) {
  let categories = [];
  let values = [];
  for (let i = 0; i < data.length; ++i) {
    const obj = data[i];
    categories.push(obj.scenarioName);
    values.push(obj.consumptionRatio.toFixed(1));
  }

  const preparedData = {
    categories,
    values,
  };

  return preparedData;
}
